"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactJss = require("react-jss");

var _Card = _interopRequireDefault(require("../Card/Card"));

var LockedstylesWithProps = function LockedstylesWithProps(props) {
  //Used to prevent the user from editing those styles other than those specified with props
  return {
    preloader: {
      position: props.FullSize === true ? "absolute" : props.ModalParentID ? "absolute" : "relative",
      zIndex: props.ZIndex ? props.ZIndex : 800,
      maxWidth: "100%",
      width: "100%",
      maxHeight: "100%",
      height: props.FullHeight ? "100%" : null,
      boxSizing: "content-box",
      // display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  };
};

var Lockedstyles = {
  //Used to Completely prevent the user from editing those styles
  LocalLoaderWrapper: {
    display: "flex",
    position: "absolute",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    boxSizing: "borderbox"
  },
  CombinedCircleWrapper: {
    position: "relative"
  },
  SVGCircleWrapper: {
    position: "absolute"
  }
};
var styles = (0, _reactJss.createUseStyles)(function (theme) {
  return {
    LocalCircularLoader: {},
    Loader: {},
    LoaderWithModal: {
      display: "flex",
      height: "100%",
      width: "100%"
    },
    ClassOverrideCard: {
      borderRadius: "0px",
      background: "none"
    },
    //Used to upload the theme classes
    LocalLoaderWrapper: theme.LocalCircularLoader.LocalLoaderWrapper,
    AnimatedCircle: theme.LocalCircularLoader.AnimatedCircle,
    "@keyframes rotatethecircle": {
      from: {
        transform: "rotate(0deg)"
      },
      to: {
        transform: "rotate(360deg)"
      }
    }
  };
});
/**
 * Create a Local Circular Loader Element
 */

var LocalCircularLoader = /*#__PURE__*/_react["default"].forwardRef(function LocalCircularLoader(props, ref) {
  var FullSize = props.FullSize,
      WithModalCard = props.WithModalCard,
      ZIndex = props.ZIndex,
      ModalCardBackground = props.ModalCardBackground,
      ModalParentID = props.ModalParentID,
      FitToParentDimensions = props.FitToParentDimensions,
      Loading = props.Loading,
      FixedCircleRadius = props.FixedCircleRadius,
      FixedCircleThickness = props.FixedCircleThickness,
      FixedCircleColor = props.FixedCircleColor,
      AnimatedCircleRadius = props.AnimatedCircleRadius,
      AnimatedCircleThickness = props.AnimatedCircleThickness,
      AnimatedCircleColor = props.AnimatedCircleColor,
      ClassOverrideLocalLoaderWrapper = props.ClassOverrideLocalLoaderWrapper,
      ClassExtendLocalLoaderWrapper = props.ClassExtendLocalLoaderWrapper,
      ClassOverrideAnimatedCircle = props.ClassOverrideAnimatedCircle,
      children = props.children;
  var theme = (0, _reactJss.useTheme)();
  var classes = styles((0, _extends2["default"])({}, props, {
    theme: theme
  }));
  var LoaderRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      LoaderHeight = _useState2[0],
      setLoaderHeight = _useState2[1];

  var calculateLoaderHeight = (0, _react.useCallback)(function () {
    if (LoaderRef && LoaderRef.current) {
      var parentHeight, ContentHeight; //Calculate the content page height

      var parentNode = LoaderRef.current.parentNode;
      parentHeight = parentNode.getBoundingClientRect().height;
      ContentHeight = parseFloat(parentHeight) + "px";
      setLoaderHeight(ContentHeight);
    }
  }, [LoaderRef]);
  (0, _react.useEffect)(function () {
    calculateLoaderHeight();
  }, [calculateLoaderHeight]); //Extracting the Theme Default values to pass them as inputs

  var FinalFixedCircleRadius = FixedCircleRadius ? FixedCircleRadius : theme.LocalCircularLoader.FixedCircleProps.CircleRadius;
  var FinalFixedCircleThickness = FixedCircleThickness ? FixedCircleThickness : theme.LocalCircularLoader.FixedCircleProps.CircleThickness;
  var FinalFixedCircleColor = FixedCircleColor ? FixedCircleColor : theme.LocalCircularLoader.FixedCircleProps.CircleColor;
  var FinalAnimatedCircleRadius = AnimatedCircleRadius ? AnimatedCircleRadius : theme.LocalCircularLoader.AnimatedCircleProps.CircleRadius;
  var FinalAnimatedCircleThickness = AnimatedCircleThickness ? AnimatedCircleThickness : theme.LocalCircularLoader.AnimatedCircleProps.CircleThickness;
  var FinalAnimatedCircleColor = AnimatedCircleColor ? AnimatedCircleColor : theme.LocalCircularLoader.AnimatedCircleProps.CircleColor;
  var FinalLoader, LoaderComp, FinaLocalLoader;
  LoaderComp = /*#__PURE__*/_react["default"].createElement("div", {
    className: ClassOverrideLocalLoaderWrapper ? ClassOverrideLocalLoaderWrapper : (0, _clsx["default"])(classes.LocalLoaderWrapper, ClassExtendLocalLoaderWrapper),
    style: (0, _extends2["default"])({}, Lockedstyles.LocalLoaderWrapper)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _extends2["default"])({}, Lockedstyles.CombinedCircleWrapper),
    className: ""
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _extends2["default"])({}, Lockedstyles.SVGCircleWrapper, {
      height: "".concat(FinalFixedCircleRadius, "px"),
      width: "".concat(FinalFixedCircleRadius, "px"),
      top: "".concat(-FinalFixedCircleRadius / 2, "px"),
      left: "".concat(-FinalFixedCircleRadius / 2, "px")
    }),
    className: ""
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "22 22 44 44"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "44",
    cy: "44",
    r: "19",
    strokeWidth: FinalFixedCircleThickness,
    fill: "none",
    stroke: FinalFixedCircleColor
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    style: (0, _extends2["default"])({}, Lockedstyles.SVGCircleWrapper, {
      height: "".concat(FinalAnimatedCircleRadius, "px"),
      width: "".concat(FinalAnimatedCircleRadius, "px"),
      top: "".concat(-FinalAnimatedCircleRadius / 2, "px"),
      left: "".concat(-FinalAnimatedCircleRadius / 2, "px")
    }),
    className: ""
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "22 22 44 44",
    className: ClassOverrideAnimatedCircle ? ClassOverrideAnimatedCircle : classes.AnimatedCircle
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "44",
    cy: "44",
    r: "19",
    strokeWidth: FinalAnimatedCircleThickness,
    fill: "none",
    stroke: FinalAnimatedCircleColor,
    strokeDashoffset: "0px",
    strokeDasharray: "90 200"
  })))));

  if (WithModalCard) {
    FinalLoader = /*#__PURE__*/_react["default"].createElement(_Card["default"], {
      CardID: "MyCard",
      IsDraggable: false,
      ParentRefCompID: ModalParentID,
      FitToParentDimensions: FitToParentDimensions,
      CardBackgroundColor: "none",
      ClassOverrideCard: classes.ClassOverrideCard,
      CardBackground: "none",
      WithPerfectScrollbar: false,
      AlertUserWhenLeavingPage: false,
      CardWindowPaddingVertical: "0px",
      CardWindowPaddingHorizontal: "0px",
      ZIndex: ZIndex ? ZIndex : 800,
      WindowBackgroundColor: ModalCardBackground // CardMaxWidth={}
      ,
      CardHeight: FullSize ? "100%" : LoaderHeight
    }, LoaderComp);
  } else {
    FinalLoader = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, LoaderComp);
  }

  if (Loading) {
    FinaLocalLoader = FinalLoader;
  } else {
    FinaLocalLoader = null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: LoaderRef,
    style: (0, _extends2["default"])({}, LockedstylesWithProps(props).preloader, {
      height: LoaderHeight,
      display: Loading ? "flex" : "none"
    }),
    className: classes.LocalCircularLoader
  }, FinaLocalLoader, children);
});

LocalCircularLoader.defaultProps = {
  FullSize: false,
  WithModalCard: false,
  ZIndex: null,
  ModalCardBackground: "rgba(0, 0, 0, 0.2)",
  ModalParentID: "",
  FitToParentDimensions: false,
  Loading: false,
  FullHeight: false,
  FixedCircleRadius: null,
  FixedCircleThickness: null,
  FixedCircleColor: null,
  AnimatedCircleRadius: null,
  AimatedCircleThickness: null,
  AnimatedCircleColor: null,
  ClassOverrideLocalLoaderWrapper: null,
  ClassExtendLocalLoaderWrapper: null,
  ClassOverrideAnimatedCircle: null
};
process.env.NODE_ENV !== "production" ? LocalCircularLoader.propTypes = {
  /**
      * Full Size - > will set all to position absolute
      */
  FullSize: _propTypes["default"].bool,

  /**
     * Z-Index
     */
  ZIndex: _propTypes["default"].any,

  /**
   * Add or not a modal card
   */
  WithModalCard: _propTypes["default"].bool,

  /**
   * Background Color of the modal card : rgba(0,0,0,0.2)
   */
  ModalCardBackground: _propTypes["default"].any,

  /**
   * id of the parent component where the card will be inserted
   */
  ModalParentID: _propTypes["default"].any,

  /**
   * Fit to the parent dimensions
   */
  FitToParentDimensions: _propTypes["default"].bool,

  /**
   * Pass the Loading props to display the loader
   */
  Loading: _propTypes["default"].bool,

  /**
   * If true set the preloader height="100%" (useful for cards and elements taking a full height)
   */
  FullHeight: _propTypes["default"].bool,

  /**
   * Radius of the fixed Circle
   */
  FixedCircleRadius: _propTypes["default"].any,

  /**
   * Thickness of the Fixed Circle
   */
  FixedCircleThickness: _propTypes["default"].any,

  /**
   * Color of the Fixed Circle
   */
  FixedCircleColor: _propTypes["default"].any,

  /**
   * Radius of the Animated Circle
   */
  AnimatedCircleRadius: _propTypes["default"].any,

  /**
   * Thickness of the Animated Circle
   */
  AimatedCircleThickness: _propTypes["default"].any,

  /**
   * Color of the Animated Circle
   */
  AnimatedCircleColor: _propTypes["default"].any,

  /**
   * Class override for the wrapper (background Color and Zindex mainly)
   */
  ClassOverrideLocalLoaderWrapper: _propTypes["default"].any,

  /**
   * Class extend for the wrapper (background Color and Zindex mainly)
   */
  ClassExtendLocalLoaderWrapper: _propTypes["default"].any,

  /**
   * Class override for the animated circle (Animation timing mainly)
   */
  ClassOverrideAnimatedCircle: _propTypes["default"].any
} : void 0;
var _default = LocalCircularLoader;
exports["default"] = _default;